import React from "react";
import { Flex, Text } from "../../assets/ui";
import styled from "styled-components";
import { LocationsIcon } from "../../assets/icons";
import { StyledButton } from "../../components/common/Button";
import ScrollDown from "../../components/common/ScrolDown";
import Theme from "../../assets/ui/theme";

const StyledSectionWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;

  & svg {
    width: 12px;
    height: auto;
  }
`;

const BannerJobDetails = ({ job, toggleModal }) => {
  return (
    <StyledSectionWrapper>
      <Text
        fontWeight="bold"
        marginBottom={["24px", null, null, "40px"]}
        lineHeight={["48px", "72px"]}
        fontSize={["48px", "72px"]}
        color={Theme.colors.white}
      >
        {job.type}
      </Text>
      <Flex alignItems="center" marginBottom={["56px", null, null, "116px"]}>
        <LocationsIcon />
        <Text
          fontWeight="bold"
          marginLeft={["12px"]}
          lineHeight={["30px"]}
          fontSize={["24px"]}
          color={Theme.colors.subTitle}
        >
          {job.location}
        </Text>
      </Flex>

      <StyledButton
        marginBottom={["106px", "75px"]}
        onClick={() => toggleModal(true)}
      >
        Make your move
      </StyledButton>
      <ScrollDown />
    </StyledSectionWrapper>
  );
};

export default BannerJobDetails;
